module.exports = __webpack_public_path__ + "img/paystatus-50.0b0caf15.png";